import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import languageUtil from "./utls/LanguageUtil";

import translationEnglish from "./translations/English.json";
import translationFrench from "./translations/French.json";
import translationSpanish from "./translations/Spanish.json";

const fallbackLng = languageUtil.AVAILABLE_LANGUAGES.fr;

const resources = {
  en: {
    translation: translationEnglish,
  },
  fr: {
    translation: translationFrench,
  },
  es: {
    translation: translationSpanish,
  },
};

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,
    detection: {
      order: ["localStorage", "navigator", "cookie", "htmlTag", "path", "subdomain"],
      caches: ["localStorage"],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18next;
